export type DocumentType = {
    id: string;
    title: string | JSX.Element;
    optionTitle: string;
    formSeries: string;
    baseFee: number;
};

export const DocumentTypes: DocumentType[] = [
    {
        id: "0",
        title: `Abstract of Judgment`,
        optionTitle: `Abstract of Judgment`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "1",
        title: `Affidavit Death of Trustee`,
        optionTitle: `Affidavit Death of Trustee`,
        formSeries: "D",
        baseFee: 14,
    },
    {
        id: "2",
        title: `Affidavit Death of Joint Tenant`,
        optionTitle: `Affidavit Death of Joint Tenant`,
        formSeries: "D",
        baseFee: 14,
    },
    {
        id: "3",
        title: `Agreement`,
        optionTitle: `Agreement`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "4",
        title: `Assignment`,
        optionTitle: `Assignment`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "5",
        title: `Assignment of Deed of Trust`,
        optionTitle: `Assignment of Deed of Trust`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "6",
        title: `Grant Deed`,
        optionTitle: `Grant Deed`,
        formSeries: "C",
        baseFee: 14,
    },
    {
        id: "7",
        title: `Judgment`,
        optionTitle: `Judgment`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "8",
        title: `Mechanic's Lien`,
        optionTitle: `Mechanic's Lien`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "9",
        title: `Modification of Deed of Trust`,
        optionTitle: `Modification of Deed of Trust`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "10",
        title: `Notice of Completion`,
        optionTitle: `Notice of Completion`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "11",
        title: `Notice of Default`,
        optionTitle: `Notice of Default`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "12",
        title: `Notice of Trustee's Sale`,
        optionTitle: `Notice of Trustee's Sale`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "13",
        title: `Order`,
        optionTitle: `Order`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "14",
        title: `Power of Attorney`,
        optionTitle: `Power of Attorney`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "15",
        title: `Quitclaim Deed`,
        optionTitle: `Quitclaim Deed`,
        formSeries: "B",
        baseFee: 14,
    },
    {
        id: "16",
        title: `Reconveyance`,
        optionTitle: `Reconveyance`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "17",
        title: `Release of Judgment Lien (Child Support)`,
        optionTitle: `Release of Judgment Lien (Child Support)`,
        formSeries: "F",
        baseFee: 20,
    },
    {
        id: "18",
        title: `Rescission of Notice of Default`,
        optionTitle: `Rescission of Notice of Default`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "19",
        title: `Revocation of Transfer on Death Deed`,
        optionTitle: `Revocation of Transfer on Death Deed`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "20",
        title: `Satisfaction of Judgment`,
        optionTitle: `Satisfaction of Judgment`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "21",
        title: `Substitution of Trustee`,
        optionTitle: `Substitution of Trustee`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "22",
        title: `Transfer on Death Deed`,
        optionTitle: `Transfer on Death Deed`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "23",
        title: `Trust Deed`,
        optionTitle: `Trust Deed`,
        formSeries: "A",
        baseFee: 14,
    },
    {
        id: "24",
        title: `Trustee's Deed`,
        optionTitle: `Trustee's Deed`,
        formSeries: "E",
        baseFee: 14,
    },
    {
        id: "25",
        title: (
            <>
                <abbr title="Uniform Commercial Code">UCC</abbr> Filings
            </>
        ),
        optionTitle: "UCC Filings",
        formSeries: "G",
        baseFee: 14,
    },
];
